import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full border border-secondary-300 bg-secondary-50 mb-6">
            <i className="ri-compass-3-line text-secondary-600 text-sm"></i>
            <span className="text-sm text-secondary-700 font-medium">探幽揽胜</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            六大热门分类
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            精心整理的漫画分类，帮您快速找到心仪的作品
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to="/category/all"
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 hover:bg-accent-50 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-12 h-12 rounded-xl bg-background-200 flex items-center justify-center mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-background-50 transition-colors`}></i>
              </div>

              {/* Info */}
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-accent-700 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {cat.description}
              </p>

              {/* Bottom */}
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.count.toLocaleString()} 部作品</span>
                <span className="flex items-center gap-1 text-sm font-medium text-foreground-700 group-hover:text-accent-600 transition-colors">
                  浏览
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}